import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorWarehouseRequestLinesCreate = () => {
  const warehouseRequestLinesCreate = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }

    ApiService.jsonRequest('/warehouse/request-lines/create', payload, (response) => {
      loading(false)
      if (response.code === 7201) {
        callback(response)
        showAlert({
          icon: 'success',
          message: getTranslate('message.successfully_created'),
          timer: 2000,
        })
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])

  return { warehouseRequestLinesCreate }
}

export default InteractorWarehouseRequestLinesCreate
